import { combineReducers } from 'redux';
import common from './common';

export default combineReducers({
    common,
});